export const locales = ['fr-FR', 'en-US']
